// core/hooks/useFingerprint.ts
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getCheggUserUuid, getUserRole } from '@src/state/auth/selectors'
import siteConfig from '@src/state/site/siteConfig'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { Cookies, getCookie } from '@src/utils/cookies'
import { getSite } from '@src/state/site/selectors'
import { isAppInitialized } from '@src/state/app/selectors'
import { RootState } from '@src/state/types'
import { setEnv, getDeviceId, Environment } from '@chegg/fingerprint-web-sdk'

export const useDeviceID = () => {
  const cheggUserUuid = useSelector(getCheggUserUuid)
  const site = useSelector(getSite)
  const role = useSelector(getUserRole)
  const search = useSelector((state: RootState) => state.router.location.search)
  const queryParams = new URLSearchParams(search)
  const authSuccess = queryParams.get('authSuccess')
  const isAppInitializationdone = useSelector(isAppInitialized)
  useEffect(() => {
    const initializeDeviceId = async () => {
      if (LOCAL_OR_PLAYGROUND) {
        setEnv(Environment.test)
      }
      const domain = siteConfig(site, LOCAL_OR_PLAYGROUND).cookieDomain
      if (cheggUserUuid) {
        const combinedUuidSessionId = cheggUserUuid + getCookie(Cookies.CSessionID)
        const combinedUuidUvn = cheggUserUuid + getCookie(Cookies._sdsat_uvn)
        const combinedUuidUvnSessionid =
          cheggUserUuid + getCookie(Cookies.CSessionID) + getCookie(Cookies._sdsat_uvn)
        await getDeviceId({
          userUuid: cheggUserUuid,
          hasSubscription: true,
          cookieDomain: domain,
          platform: 'WEB',
          combined_uuid_sessionId: combinedUuidSessionId,
          combined_uuid_uvn: combinedUuidUvn,
          combined_uuid_uvn_sessionid: combinedUuidUvnSessionid,
        })
      }
    }

    initializeDeviceId()
  }, [cheggUserUuid, Cookies.DFID, role, isAppInitializationdone, authSuccess])
}



// WEBPACK FOOTER //
// ./src/hooks/useDeviceID.tsx